import { adaptMedias } from '@/features/messages/hooks/useAttachmentUpload';
import { ExerciseInstructionInput, TaskInstruction } from '@/types/schema';

export default function adaptInstruction(
  instruction?: TaskInstruction | ExerciseInstructionInput | null,
) {
  if (!instruction) {
    return instruction;
  }
  return {
    ...instruction,
    medias: adaptMedias(instruction.medias),
  };
}
